import { UploadField } from 'validations/uploadImage';

import { getPuzzlePremiumTierLabel } from '../../CreatePuzzleScreen/utilities';

export const formDefaultValues = {
  [UploadField.PremiumTier]: { value: 0, label: getPuzzlePremiumTierLabel(0) },
  [UploadField.AIGenerated]: true,
};
